import { default as MuiFormGroup } from '@mui/material/FormGroup';

/**
 * FormGroup wraps controls such as Checkbox and Switch, providing compact row or column layouts.
 *
 * Demos:
 *
 * - [Checkbox](https://unify.workiva.org/components/checkbox?tab=code)
 *
 * API:
 *
 * - [FormGroup API](https://unify.workiva.org/components/checkbox?tab=code#form-group)
 */
export const FormGroup = MuiFormGroup;
export { type FormGroupProps, formGroupClasses } from '@mui/material/FormGroup';
